import settingJson from "./settings.json"

export const settings = {
  checkPermission: false,
  version: settingJson.version,
};
